import React from 'react';

const withLayout = (PageComponent) => {
  return function WithPage({ ...props }) {
    return (
      <div>
        <h2>Header Title</h2>
        <PageComponent />
        <h2>Footer</h2>
      </div>
    );
  };
};

export default withLayout;
